import React from "react";
import { useTranslation } from "react-i18next";
import { Badge } from "@/components/ui/badge";
import { MessageDeliveryStatus } from "@/types/message-delivery";

type BadgeVariant = React.ComponentProps<typeof Badge>["variant"];

const STATUS_BADGE_VARIANT: Record<MessageDeliveryStatus, BadgeVariant> = {
  QUEUED: "status_new",
  SENT: "status_in_progress",
  DELIVERED: "status_done",
  READ: "verified",
  FAILED: "status_canceled",
  REJECTED: "new_destructive",
};

interface DeliveryStatusBadgeProps {
  status: MessageDeliveryStatus;
}

export const DeliveryStatusBadge: React.FC<DeliveryStatusBadgeProps> = ({
  status,
}) => {
  const { t } = useTranslation();
  return (
    <Badge variant={STATUS_BADGE_VARIANT[status]}>
      {t(`communicationChannels.deliveries.status.${status}`)}
    </Badge>
  );
};
